import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import remarkStringify from "remark-stringify";
import { unified } from "unified";

type Node = { type: string; value?: string; children?: Node[] };

// A soft line break is only a space in Markdown, which glues "Best," to the
// name under it. Drafts are written as plain text, so keep their line breaks.
function hardBreaks(node: Node) {
  if (!node.children) return;
  node.children = node.children.flatMap((child) => {
    if (child.type !== "text" || !child.value?.includes("\n")) {
      hardBreaks(child);
      return [child];
    }
    return child.value
      .split("\n")
      .flatMap((value, index) =>
        index ? [{ type: "break" }, { type: "text", value }] : [{ type: "text", value }],
      );
  });
}

// DLS Markdown supports raw HTML. Remove HTML nodes before rendering source content.
export function sourceMarkdown(content: string, options: { breaks?: boolean } = {}) {
  const processor = unified().use(remarkParse).use(remarkGfm).use(remarkStringify);
  const tree = processor.parse(content);
  function clean(node: { children?: Array<{ type: string; children?: unknown[] }> }) {
    if (!node.children) return;
    node.children = node.children.filter((child) => child.type !== "html");
    for (const child of node.children) clean(child as typeof node);
  }
  clean(tree);
  if (options.breaks) hardBreaks(tree as Node);
  return processor.stringify(tree);
}
